import React from "react";
import { useParams } from "react-router-dom";
import { useData } from "../../../../../components/SiteMap/contexts/DataContext";
import SiteMapArrowRoute from "../../../../../components/SiteMap/routes/ArrowRoute";

const SiteMapArrowPage = () => {
  const { arrowId } = useParams();
  const { arrows } = useData();

  const arrow = arrows.find(
    (arrow) => arrowId && arrow.id === parseInt(arrowId),
  );

  return (
    <>
      <SiteMapArrowRoute arrow={arrow} />
    </>
  );
};

export default SiteMapArrowPage;
